<template>
  <a
    href="#"
    class="navi-modal-menu-item px-2 py-1 text--medium d-block"
    @click.prevent="disabled ? null : $emit('click')"
    :class="{ 'navi-modal-menu-item--active': active, 'navi-modal-menu-item--disabled': disabled }"
  >
    <slot></slot>
  </a>
</template>

<script>
/**
 * @displayName Navi modal item
 */

export default {
  props: {
    active: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
  .navi-modal-menu-item {
    color: $color-black;

    &:link, &:visited {
      color: $color-black;
    }

    &:hover, &--active {
      background-color: lighten($color-primary, 45);

      &:link, &:visited {
        color: lighten($color-black, 10);
      }
    }

    &--active {
      background-color: lighten($color-primary, 47);
    }

    &--disabled {
      background-color: $color-grey-extra-light;
      cursor: unset;

      &:hover, &--active {
        background-color: $color-grey-extra-light;
        color: $color-grey-light;

        &:link, &:visited {
          background-color: $color-grey-extra-light;
          color: $color-grey-dark;
        }
      }
    }
  }
</style>
